// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Launch a free giveaway`
};

const de_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Gewinnspiel starten`
};

const es_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Lanza un sorteo gratuito`
};

const fr_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Lancer un concours gratuit`
};

const fi_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Käynnistä ilmainen arvonta`
};

const hi_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `मुफ्त गिवअवे शुरू करें`
};

const ja_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `無料プレゼント企画を開始`
};

const nl_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Start een gratis weggeefactie`
};

const pt_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Lançar um sorteio gratuito`
};

const ro_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Lansează un concurs gratuit`
};

const th_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `เริ่มการแจกของฟรี`
};

const ur_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `مفت مقابلہ شروع کریں`
};

const zh_hant1_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `啟動免費贈品活動`
};

const da_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Start en gratis giveaway`
};

const it_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Lancia un giveaway gratuito`
};

const vn_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Khởi chạy một cuộc tặng quà miễn phí`
};

const ko_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `무료 경품 이벤트 시작하기`
};

const tr_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Ücretsiz çekiliş başlat`
};

const lv_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Sāciet bezmaksas loteriju`
};

const ar_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `إطلاق مسابقة مجانية`
};

const bs_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Pokrenite besplatnu nagradnu igru`
};

const sl_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Zaženite brezplačno nagradno igro`
};

const id_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Luncurkan giveaway gratis`
};

const sv_widget_launch_giveaway = /** @type {(inputs: {}) => string} */ () => {
	return `Starta en gratis utlottning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_launch_giveaway = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_launch_giveaway(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_launch_giveaway", locale)
	if (locale === "en") return en_widget_launch_giveaway(inputs)
	if (locale === "de") return de_widget_launch_giveaway(inputs)
	if (locale === "es") return es_widget_launch_giveaway(inputs)
	if (locale === "fr") return fr_widget_launch_giveaway(inputs)
	if (locale === "fi") return fi_widget_launch_giveaway(inputs)
	if (locale === "hi") return hi_widget_launch_giveaway(inputs)
	if (locale === "ja") return ja_widget_launch_giveaway(inputs)
	if (locale === "nl") return nl_widget_launch_giveaway(inputs)
	if (locale === "pt") return pt_widget_launch_giveaway(inputs)
	if (locale === "ro") return ro_widget_launch_giveaway(inputs)
	if (locale === "th") return th_widget_launch_giveaway(inputs)
	if (locale === "ur") return ur_widget_launch_giveaway(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_launch_giveaway(inputs)
	if (locale === "da") return da_widget_launch_giveaway(inputs)
	if (locale === "it") return it_widget_launch_giveaway(inputs)
	if (locale === "vn") return vn_widget_launch_giveaway(inputs)
	if (locale === "ko") return ko_widget_launch_giveaway(inputs)
	if (locale === "tr") return tr_widget_launch_giveaway(inputs)
	if (locale === "lv") return lv_widget_launch_giveaway(inputs)
	if (locale === "ar") return ar_widget_launch_giveaway(inputs)
	if (locale === "bs") return bs_widget_launch_giveaway(inputs)
	if (locale === "sl") return sl_widget_launch_giveaway(inputs)
	if (locale === "id") return id_widget_launch_giveaway(inputs)
	if (locale === "sv") return sv_widget_launch_giveaway(inputs)
	return "widget_launch_giveaway"
};